<template>
  <div class="variables-wrapper">
    <div v-if="!allVariables || !allVariables.data || !allVariables.data.server || !servers[allVariables.data.server]" class="text-center py-5">
      <b-spinner label="Loading..." variant="primary"></b-spinner>
      <p class="text-muted mt-2">Loading variables...</p>
    </div>
    
    <div v-else class="animated fadeIn">
      <b-alert v-if="servers[allVariables.data.server].readonly" show variant="warning" class="mb-3">
        <i class="fa fa-lock"></i> This server is currently in <strong>Read-only</strong> mode. Variable changes are disabled.
      </b-alert>

      <!-- Variables Grid -->
      <div class="rounded shadow-sm border" style="min-height: 500px;">
        <VariableRecords 
          :records="allVariables.data.data" 
          :readonly="servers[allVariables.data.server].readonly" 
          :server="allVariables.data.server"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Servers from '../../../_servers'
  import VariableRecords from './VariableRecords'
  import { mapGetters } from 'vuex'

  export default {
    name: 'Variables',
    components: {
      VariableRecords
    },
    props: {
      username: { type: String, required: true },
      server: { type: String, required: true }
    },
    computed: mapGetters({
      allVariables: 'variables'
    }),
    data () {
      return {
        servers: Servers
      }
    },
    watch: {
      username: 'fetchData',
      server: 'fetchData'
    },
    created () {
      this.fetchData()
    },
    methods: {
      fetchData() {
        if (this.username && this.server) {
          this.emit('getVariables', {
            username: this.username, 
            server: this.server
          })
        }
      }
    }
  }
</script>

